import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

export async function fetchRegions() {
  const { data } = await api.get("/regions");
  return data.regions;
}
export async function fetchRegion(slug) {
  const { data } = await api.get(`/regions/${slug}`);
  return data;
}
export async function fetchCities() {
  const { data } = await api.get("/cities");
  return data.cities;
}
export async function fetchFX(base, target, amount) {
  const { data } = await api.get("/fx", { params: { base, target, amount } });
  return data;
}
export async function fetchDistance(from, to) {
  const { data } = await api.get("/distance", { params: { from, to } });
  return data;
}
export async function fetchWeather(city) {
  const { data } = await api.get("/weather", { params: { city } });
  return data;
}
export async function fetchPhrasebook() {
  const { data } = await api.get("/phrasebook");
  return data;
}
export async function postBudget(payload) {
  const { data } = await api.post("/budget", payload);
  return data;
}
export async function fetchListings(params) {
  const { data } = await api.get("/listings", { params });
  return data;
}
export async function fetchListing(slug) {
  const { data } = await api.get(`/listings/${slug}`);
  return data;
}
export async function subscribeNewsletter(email, locale) {
  const { data } = await api.post("/newsletter", { email, locale });
  return data;
}


